"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tooltip = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const tooltip_bubble_1 = require("@/components/overlay/tooltip/tooltip-bubble");
const tooltip_styles_1 = require("@/components/overlay/tooltip/tooltip.styles");
/**
 * 트리거를 감싸 hover·포커스를 듣고, 말풍선(mm-tooltip-bubble)을 띄우고 거두는 일을 소유합니다.
 * 말풍선은 portal 컨테이너로 옮겨지므로 처음 열릴 때 만들고, 연결이 끊기면 함께 지웁니다.
 * 트리거는 대개 다른 shadow root 안에 있어 id 참조(aria-describedby)가 닿지 않으므로, 내용은 대상 요소의 aria-description으로 직접 싣습니다.
 */
let Tooltip = class Tooltip extends lit_1.LitElement {
    constructor() {
        super();
        this.content = '';
        this.placement = 'bottom-start';
        this.open = false;
        this.descriptionTargets = new Set();
        this.handleTriggerShow = () => {
            this.syncDescription();
            this.open = true;
        };
        this.handleTriggerHide = () => {
            this.open = false;
        };
        this.handleTriggerSlotChange = () => {
            this.syncDescription();
        };
        // 트리거는 대개 다른 shadow root 안에 있어 id 참조(aria-describedby)가 닿지 않으므로 내용을 직접 싣는다.
        this.syncDescription = () => {
            this.clearDescriptionTargets();
            this.triggerElements.forEach(element => {
                const target = this.findDescriptionTarget(element);
                // 이름과 같은 내용을 설명으로 다시 읽히지 않게 한다.
                if (!target || target.getAttribute('aria-label') === this.content)
                    return;
                target.setAttribute('aria-description', this.content);
                this.descriptionTargets.add(target);
            });
        };
        // 리스너 대상이 host 자신이라 연결이 바뀌어도 유지되므로 생성자에서 한 번만 등록한다.
        this.addEventListener('mouseover', this.handleTriggerShow);
        this.addEventListener('mouseout', this.handleTriggerHide);
        this.addEventListener('focusin', this.handleTriggerShow);
        this.addEventListener('focusout', this.handleTriggerHide);
    }
    render() {
        return (0, lit_1.html) `
      <slot name="trigger" @slotchange=${this.handleTriggerSlotChange}></slot>
    `;
    }
    updated() {
        this.syncBubble();
    }
    disconnectedCallback() {
        this.clearDescriptionTargets();
        this.removeBubble();
        super.disconnectedCallback();
    }
    // 말풍선은 처음 열릴 때 만들어, 한 번도 보이지 않은 트리거는 문서에 아무것도 더하지 않는다.
    syncBubble() {
        if (!this.bubble && !this.open)
            return;
        this.bubble ??= this.createBubble();
        this.bubble.content = this.content;
        this.bubble.placement = this.placement;
        this.bubble.anchor = this;
        this.bubble.open = this.open;
    }
    // 연결되는 순간 말풍선이 스스로 portal 컨테이너로 옮겨간다.
    createBubble() {
        const bubble = new tooltip_bubble_1.TooltipBubble();
        this.renderRoot.append(bubble);
        return bubble;
    }
    removeBubble() {
        this.bubble?.remove();
        this.bubble = undefined;
    }
    findDescriptionTarget(element) {
        const focusableSelector = 'button, a[href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
        if (element instanceof HTMLElement && element.matches(focusableSelector))
            return element;
        const roots = [element.shadowRoot, element].filter(Boolean);
        for (const root of roots) {
            for (const child of root.children) {
                const target = this.findDescriptionTarget(child);
                if (target)
                    return target;
            }
        }
        return null;
    }
    clearDescriptionTargets() {
        this.descriptionTargets.forEach(target => target.removeAttribute('aria-description'));
        this.descriptionTargets.clear();
    }
};
Tooltip.styles = [tooltip_styles_1.tooltipTriggerStyles];
__decorate([
    (0, decorators_js_1.property)({ type: String })
], Tooltip.prototype, "content", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, reflect: true })
], Tooltip.prototype, "placement", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: Boolean, reflect: true })
], Tooltip.prototype, "open", void 0);
__decorate([
    (0, decorators_js_1.queryAssignedElements)({ slot: 'trigger', flatten: true })
], Tooltip.prototype, "triggerElements", void 0);
Tooltip = __decorate([
    (0, decorators_js_1.customElement)('mm-tooltip')
], Tooltip);
exports.Tooltip = Tooltip;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidG9vbHRpcC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbInRvb2x0aXAudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBQUEsNkJBQXNDO0FBQ3RDLHFEQUFrRjtBQUlsRixnRkFBMkU7QUFDM0UsZ0ZBQWtGO0FBS2xGOzs7O0dBSUc7QUFFSSxJQUFNLE9BQU8sR0FBYixNQUFNLE9BQVEsU0FBUSxnQkFBVTtJQW9CckM7UUFDRSxLQUFLLEVBQUUsQ0FBQTtRQW5CbUIsWUFBTyxHQUFHLEVBQUUsQ0FBQTtRQUNHLGNBQVMsR0FBcUIsY0FBYyxDQUFBO1FBQzNDLFNBQUksR0FBRyxLQUFLLENBQUE7UUFJaEQsdUJBQWtCLEdBQUcsSUFBSSxHQUFHLEVBQWUsQ0FBQTtRQUMzQyxzQkFBaUIsR0FBRyxHQUFHLEVBQUU7WUFDL0IsSUFBSSxDQUFDLGVBQWUsRUFBRSxDQUFBO1lBQ3RCLElBQUksQ0FBQyxJQUFJLEdBQUcsSUFBSSxDQUFBO1FBQ2xCLENBQUMsQ0FBQTtRQUNPLHNCQUFpQixHQUFHLEdBQUcsRUFBRTtZQUMvQixJQUFJLENBQUMsSUFBSSxHQUFHLEtBQUssQ0FBQTtRQUNuQixDQUFDLENBQUE7UUFDTyw0QkFBdUIsR0FBRyxHQUFHLEVBQUU7WUFDckMsSUFBSSxDQUFDLGVBQWUsRUFBRSxDQUFBO1FBQ3hCLENBQUMsQ0FBQTtRQXdFRCw0RUFBNEU7UUFDcEUsb0JBQWUsR0FBRyxHQUFHLEVBQUU7WUFDN0IsSUFBSSxDQUFDLHVCQUF1QixFQUFFLENBQUE7WUFFOUIsSUFBSSxDQUFDLGVBQWUsQ0FBQyxPQUFPLENBQUMsT0FBTyxDQUFDLEVBQUU7Z0JBQ3JDLE1BQU0sTUFBTSxHQUFHLElBQUksQ0FBQyxxQkFBcUIsQ0FBQyxPQUFPLENBQUMsQ0FBQTtnQkFDbEQsZ0NBQWdDO2dCQUNoQyxJQUFJLENBQUMsTUFBTSxJQUFJLE1BQU0sQ0FBQyxZQUFZLENBQUMsWUFBWSxDQUFDLEtBQUssSUFBSSxDQUFDLE9BQU87b0JBQUUsT0FBTTtnQkFFekUsTUFBTSxDQUFDLFlBQVksQ0FBQyxrQkFBa0IsRUFBRSxJQUFJLENBQUMsT0FBTyxDQUFDLENBQUE7Z0JBQ3JELElBQUksQ0FBQyxrQkFBa0IsQ0FBQyxHQUFHLENBQUMsTUFBTSxDQUFDLENBQUE7WUFDckMsQ0FBQyxDQUFDLENBQUE7UUFDSixDQUFDLENBQUE7UUFoRkMsb0RBQW9EO1FBQ3BELElBQUksQ0FBQyxnQkFBZ0IsQ0FBQyxXQUFXLEVBQUUsSUFBSSxDQUFDLGlCQUFpQixDQUFDLENBQUE7UUFDMUQsSUFBSSxDQUFDLGdCQUFnQixDQUFDLFVBQVUsRUFBRSxJQUFJLENBQUMsaUJBQWlCLENBQUMsQ0FBQTtRQUN6RCxJQUFJLENBQUMsZ0JBQWdCLENBQUMsU0FBUyxFQUFFLElBQUksQ0FBQyxpQkFBaUIsQ0FBQyxDQUFBO1FBQ3hELElBQUksQ0FBQyxnQkFBZ0IsQ0FBQyxVQUFVLEVBQUUsSUFBSSxDQUFDLGlCQUFpQixDQUFDLENBQUE7SUFDM0QsQ0FBQztJQUVELE1BQU07UUFDSixPQUFPLElBQUEsVUFBSSxFQUFBO3lDQUMwQixJQUFJLENBQUMsdUJBQXVCO0tBQ2hFLENBQUE7SUFDSCxDQUFDO0lBRVMsT0FBTztRQUNmLElBQUksQ0FBQyxVQUFVLEVBQUUsQ0FBQTtJQUNuQixDQUFDO0lBRUQsb0JBQW9CO1FBQ2xCLElBQUksQ0FBQyx1QkFBdUIsRUFBRSxDQUFBO1FBQzlCLElBQUksQ0FBQyxZQUFZLEVBQUUsQ0FBQTtRQUNuQixLQUFLLENBQUMsb0JBQW9CLEVBQUUsQ0FBQTtJQUM5QixDQUFDO0lBRUQsdURBQXVEO0lBQy9DLFVBQVU7UUFDaEIsSUFBSSxDQUFDLElBQUksQ0FBQyxNQUFNLElBQUksQ0FBQyxJQUFJLENBQUMsSUFBSTtZQUFFLE9BQU07UUFFdEMsSUFBSSxDQUFDLE1BQU0sS0FBSyxJQUFJLENBQUMsWUFBWSxFQUFFLENBQUE7UUFDbkMsSUFBSSxDQUFDLE1BQU0sQ0FBQyxPQUFPLEdBQUcsSUFBSSxDQUFDLE9BQU8sQ0FBQTtRQUNsQyxJQUFJLENBQUMsTUFBTSxDQUFDLFNBQVMsR0FBRyxJQUFJLENBQUMsU0FBUyxDQUFBO1FBQ3RDLElBQUksQ0FBQyxNQUFNLENBQUMsTUFBTSxHQUFHLElBQUksQ0FBQTtRQUN6QixJQUFJLENBQUMsTUFBTSxDQUFDLElBQUksR0FBRyxJQUFJLENBQUMsSUFBSSxDQUFBO0lBQzlCLENBQUM7SUFFRCxzQ0FBc0M7SUFDOUIsWUFBWTtRQUNsQixNQUFNLE1BQU0sR0FBRyxJQUFJLDhCQUFhLEVBQUUsQ0FBQTtRQUNsQyxJQUFJLENBQUMsVUFBVSxDQUFDLE1BQU0sQ0FBQyxNQUFNLENBQUMsQ0FBQTtRQUM5QixPQUFPLE1BQU0sQ0FBQTtJQUNmLENBQUM7SUFFTyxZQUFZO1FBQ2xCLElBQUksQ0FBQyxNQUFNLEVBQUUsTUFBTSxFQUFFLENBQUE7UUFDckIsSUFBSSxDQUFDLE1BQU0sR0FBRyxTQUFTLENBQUE7SUFDekIsQ0FBQztJQUVPLHFCQUFxQixDQUFDLE9BQWdCO1FBQzVDLE1BQU0saUJBQWlCLEdBQ3JCLDJFQUEyRSxDQUFBO1FBRTdFLElBQUksT0FBTyxZQUFZLFdBQVcsSUFBSSxPQUFPLENBQUMsT0FBTyxDQUFDLGlCQUFpQixDQUFDO1lBQUUsT0FBTyxPQUFPLENBQUE7UUFFeEYsTUFBTSxLQUFLLEdBQUcsQ0FBQyxPQUFPLENBQUMsVUFBVSxFQUFFLE9BQU8sQ0FBQyxDQUFDLE1BQU0sQ0FBQyxPQUFPLENBQTZCLENBQUE7UUFDdkYsS0FBSyxNQUFNLElBQUksSUFBSSxLQUFLLEVBQUU7WUFDeEIsS0FBSyxNQUFNLEtBQUssSUFBSSxJQUFJLENBQUMsUUFBUSxFQUFFO2dCQUNqQyxNQUFNLE1BQU0sR0FBRyxJQUFJLENBQUMscUJBQXFCLENBQUMsS0FBSyxDQUFDLENBQUE7Z0JBQ2hELElBQUksTUFBTTtvQkFBRSxPQUFPLE1BQU0sQ0FBQTthQUMxQjtTQUNGO1FBRUQsT0FBTyxJQUFJLENBQUE7SUFDYixDQUFDO0lBRU8sdUJBQXVCO1FBQzdCLElBQUksQ0FBQyxrQkFBa0IsQ0FBQyxPQUFPLENBQUMsTUFBTSxDQUFDLEVBQUUsQ0FBQyxNQUFNLENBQUMsZUFBZSxDQUFDLGtCQUFrQixDQUFDLENBQUMsQ0FBQTtRQUNyRixJQUFJLENBQUMsa0JBQWtCLENBQUMsS0FBSyxFQUFFLENBQUE7SUFDakMsQ0FBQzs7QUF2Rk0sY0FBTSxHQUFHLENBQUMscUNBQW9CLENBQUMsQ0FBQTtBQUNWO0lBQTNCLElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxNQUFNLEVBQUUsQ0FBQzt3Q0FBYTtBQUNHO0lBQTFDLElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxNQUFNLEVBQUUsT0FBTyxFQUFFLElBQUksRUFBRSxDQUFDOzBDQUE2QztBQUMzQztJQUEzQyxJQUFBLHdCQUFRLEVBQUMsRUFBRSxJQUFJLEVBQUUsT0FBTyxFQUFFLE9BQU8sRUFBRSxJQUFJLEVBQUUsQ0FBQztxQ0FBYTtBQUV4RDtJQURDLElBQUEscUNBQXFCLEVBQUMsRUFBRSxJQUFJLEVBQUUsU0FBUyxFQUFFLE9BQU8sRUFBRSxJQUFJLEVBQUUsQ0FBQztnREFDdkI7QUFOeEIsT0FBTztJQURuQixJQUFBLDZCQUFhLEVBQUMsWUFBWSxDQUFDO0dBQ2YsT0FBTyxDQXVHbkI7QUF2R1ksMEJBQU8ifQ==